/**
 * Q11 §3b — persona labelling for the care-professional side.
 *
 * PRIMARY RULE: prefer the specific role label wherever the system knows it.
 * An RN should see "RN" on their own workspace header — never a generic
 * umbrella term. RNs/RPNs object to "caregiver" (it connotes PSW/companion
 * work and reads as a demotion of regulated professional standing), and the
 * cleanest fix is simply to show them what they actually are.
 *
 * The umbrella term is the fallback ONLY — used when no role is declared
 * (e.g. a brand-new applicant who hasn't picked a role yet).
 */

/** The locked user-facing umbrella term (Q11 §3b). Short form: "Professional". */
export const CARE_PROFESSIONAL_UMBRELLA = 'Care Professional';

/** Separator between multiple declared roles, e.g. "PSW · RPN". */
const ROLE_SEPARATOR = ' · ';

/**
 * Derive the workspace header label from a care professional's declared roles.
 *
 *   [{ code: 'RN' }]                 → "RN"
 *   [{ code: 'PSW' }, { code:'RPN'}] → "PSW · RPN"
 *   []                               → "Care Professional"
 */
export function personaLabelForRoles(roles: { code: string }[]): string {
  const codes = roles.map((r) => r.code.trim()).filter((code) => code !== '');
  if (codes.length === 0) return CARE_PROFESSIONAL_UMBRELLA;
  return codes.join(ROLE_SEPARATOR);
}
